import { createSlice } from "@reduxjs/toolkit";

/**
 * 파일명: scrollSlice.js
 * 작성자: 강연승
 * 작성일자: 25.02.12
 * 설명: 스크롤 정보
 */
const scrollSlice = createSlice({
  name: "scrollSlice",
  initialState: {
    scrollPosition: 0,
    scrollToTopHandler: function () {},
  },
  reducers: {
    setScroll: (state, action) => {
      state.scrollPosition = action.payload.scrollPosition;
      state.scrollToTopHandler = () => {
        action.payload.scrollToTopHandler();
      };
    },
    resetScroll: (state) => {
      state.scrollPosition = 0;
    },
  },
});

export default scrollSlice;

export const { setScroll, resetScroll } = scrollSlice.actions;
